/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Gsoa_ActionOfferProductCatalog_Products } from '../models/Gsoa_ActionOfferProductCatalog_Products';
import type { Gsoa_ActionOffers_ActionOffer } from '../models/Gsoa_ActionOffers_ActionOffer';
import type { Gsoa_ActionOffers_ActionOffers } from '../models/Gsoa_ActionOffers_ActionOffers';
import type { Gsoa_ActionOffers_ActionProducts } from '../models/Gsoa_ActionOffers_ActionProducts';
import type { Gsoa_ActionOffers_CategoriesWithProductCount } from '../models/Gsoa_ActionOffers_CategoriesWithProductCount';
import type { Gsoa_ActionOffers_Documents } from '../models/Gsoa_ActionOffers_Documents';
import type { Gsoa_ActionOffers_Feed } from '../models/Gsoa_ActionOffers_Feed';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class GsoaActionOffersService {
    /**
     * @returns void
     * @throws ApiError
     */
    public static getApiVGsoaActionOffersIsAlive({
        apiVersion = 1,
    }: {
        apiVersion?: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/actionOffers/isAlive',
            path: {
                'apiVersion': apiVersion,
            },
        });
    }
    /**
     * @returns Gsoa_ActionOffers_Feed Success
     * @throws ApiError
     */
    public static getActionOffersFeed({
        apiVersion = 1,
        year,
        houseNumber,
    }: {
        apiVersion?: number,
        year?: number,
        houseNumber?: number,
    }): CancelablePromise<Array<Gsoa_ActionOffers_Feed>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/actionOffers/feed',
            path: {
                'apiVersion': apiVersion,
            },
            query: {
                'year': year,
                'houseNumber': houseNumber,
            },
            errors: {
                304: `Not Modified`,
                400: `Validation error.`,
                401: `An error occurred.`,
                404: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * @returns Gsoa_ActionOffers_ActionOffers Success
     * @throws ApiError
     */
    public static getActionOffers({
        houseNumber,
        apiVersion = 1,
        page,
        pageSize = 50,
        filter,
        orderBy,
    }: {
        houseNumber: number,
        apiVersion?: number,
        /**
         * Page order number (starts at 0)
         */
        page?: number,
        /**
         * The number of items per page
         */
        pageSize?: number,
        /**
         * <b>Filtering on response attributes</b>
         * <p>
         * <details>
         * <summary><b>Supported operators:</b></summary>
         * <p></p>
         * </details>
         * <details>
         * <summary><b>Supported attributes - examples:</b></summary>
         * <p></p>
         * </details>
         * </p>
         * Filter is searched for presence of validFrom and validTo.
         * If those parts are missing following filter parts are added:
         * validFrom:lt {today};;validTo:gt {today}
         */
        filter?: string,
        /**
         * <b>Ordering ASC/DESC</b>
         */
        orderBy?: string,
    }): CancelablePromise<Gsoa_ActionOffers_ActionOffers> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/actionOffers/houses/{houseNumber}/actionOffers',
            path: {
                'apiVersion': apiVersion,
                'houseNumber': houseNumber,
            },
            query: {
                'page': page,
                'pageSize': pageSize,
                'filter': filter,
                'orderBy': orderBy,
            },
            errors: {
                304: `Not Modified`,
                400: `Validation error.`,
                401: `An error occurred.`,
                404: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * @returns Gsoa_ActionOffers_Documents Success
     * @throws ApiError
     */
    public static getActionOffersDocuments({
        houseNumber,
        apiVersion = 1,
        page,
        pageSize = 50,
        filter,
        orderBy,
        orderingRule,
        hideInComplete,
    }: {
        houseNumber: number,
        apiVersion?: number,
        /**
         * Page order number (starts at 0)
         */
        page?: number,
        /**
         * The number of items per page
         */
        pageSize?: number,
        /**
         * <b>Filtering on response attributes</b><p><details><summary><b>Supported operators:</b></summary><p><i>gt</i> - checks if attribute is greater then or equal.
         * <i>gt</i> - checks if attribute is greater then.
         * <i>le</i> - checks if attribute is less than or equal.
         * <i>lt</i> - checks if attribute is less than.
         * <i>eq</i> - checks if attribute is equals. Case sensitive when literal attribute.
         * <i>in</i> - checks if attribute equals one of posibilities. Case sensitive when literal attribute.
         * </p></details><details><summary><b>Supported attributes - examples:</b></summary><p>ValidFrom:ge 123 </br>ValidFrom:gt 123 </br>ValidFrom:le 123 </br>ValidFrom:lt 123 </br>ValidFrom:eq Abc </br>ValidTo:ge 123 </br>ValidTo:gt 123 </br>ValidTo:le 123 </br>ValidTo:lt 123 </br>ValidTo:eq Abc </br>ActionOfferId:eq Abc </br>ActionOfferId:in Abc,def,ghi </br>OfferType:eq Catalogue <span class="prop-type">Enum:[ Catalogue, Flyer ]</span> </br>OfferType:in Catalogue <span class="prop-type">Enum:[ Catalogue, Flyer ]</span> </br></p></details>Combinations possible, concatenation with ";;" means logical AND. E.g.: ValidFrom:ge 123;;ValidFrom:gt 123 </p>
         */
        filter?: string,
        /**
         * <b>Ordering ASC/DESC</b>
         */
        orderBy?: string,
        /**
         * Specific filtering rules. Default value is 0.
         */
        orderingRule?: string,
        /**
         * Whether to suppress the listing of incomplete documents (thematic pages). Default value is false.
         */
        hideInComplete?: boolean,
    }): CancelablePromise<Gsoa_ActionOffers_Documents> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/actionOffers/houses/{houseNumber}/documents',
            path: {
                'apiVersion': apiVersion,
                'houseNumber': houseNumber,
            },
            query: {
                'page': page,
                'pageSize': pageSize,
                'filter': filter,
                'orderBy': orderBy,
                'orderingRule': orderingRule,
                'hideInComplete': hideInComplete,
            },
            errors: {
                304: `Not Modified`,
                400: `Validation error.`,
                401: `An error occurred.`,
                404: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * @returns Gsoa_ActionOffers_CategoriesWithProductCount Success
     * @throws ApiError
     */
    public static getActionOffersCategoriesProductCount({
        houseNumber,
        apiVersion = 1,
        page,
        pageSize = 50,
        filter,
        orderBy,
    }: {
        houseNumber: number,
        apiVersion?: number,
        /**
         * Page order number (starts at 0)
         */
        page?: number,
        /**
         * The number of items per page
         */
        pageSize?: number,
        /**
         * <b>Filtering on response attributes</b>
         * <p>
         * <details>
         * <summary><b>Supported operators:</b></summary>
         * <p></p>
         * </details>
         * <details>
         * <summary><b>Supported attributes - examples:</b></summary>
         * <p></p>
         * </details>
         * </p>
         * Filter is searched for presence of validFrom and validTo.
         * If those parts are missing following filter parts are added:
         * validFrom:lt {today};;validTo:gt {today}
         */
        filter?: string,
        /**
         * <b>Ordering ASC/DESC</b>
         */
        orderBy?: string,
    }): CancelablePromise<Gsoa_ActionOffers_CategoriesWithProductCount> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/actionOffers/houses/{houseNumber}/actionOffers/categoriesWithProductCount',
            path: {
                'apiVersion': apiVersion,
                'houseNumber': houseNumber,
            },
            query: {
                'page': page,
                'pageSize': pageSize,
                'filter': filter,
                'orderBy': orderBy,
            },
            errors: {
                304: `Not Modified`,
                400: `Validation error.`,
                401: `An error occurred.`,
                404: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * @returns Gsoa_ActionOffers_ActionOffer Success
     * @throws ApiError
     */
    public static getActionOffer({
        houseNumber,
        offerId,
        apiVersion = 1,
    }: {
        houseNumber: number,
        offerId: string,
        apiVersion?: number,
    }): CancelablePromise<Gsoa_ActionOffers_ActionOffer> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/actionOffers/houses/{houseNumber}/actionOffers/{offerId}',
            path: {
                'apiVersion': apiVersion,
                'houseNumber': houseNumber,
                'offerId': offerId,
            },
            errors: {
                304: `Not Modified`,
                400: `Validation error.`,
                401: `An error occurred.`,
                404: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * @returns Gsoa_ActionOffers_ActionOffer Success
     * @throws ApiError
     */
    public static getActionOfferBySlug({
        houseNumber,
        slug,
        apiVersion = 1,
        actionOfferHistory,
    }: {
        houseNumber: number,
        slug: string,
        apiVersion?: number,
        actionOfferHistory?: boolean,
    }): CancelablePromise<Gsoa_ActionOffers_ActionOffer> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/actionOffers/houses/{houseNumber}/actionOffers/slug/{slug}',
            path: {
                'apiVersion': apiVersion,
                'houseNumber': houseNumber,
                'slug': slug,
            },
            query: {
                'actionOfferHistory': actionOfferHistory,
            },
            errors: {
                304: `Not Modified`,
                400: `Validation error.`,
                401: `An error occurred.`,
                404: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * @returns Gsoa_ActionOffers_ActionProducts Success
     * @throws ApiError
     */
    public static getActionProducts({
        houseNumber,
        apiVersion = 1,
        page,
        pageSize = 50,
        filter,
        orderBy,
    }: {
        houseNumber: number,
        apiVersion?: number,
        /**
         * Page order number (starts at 0)
         */
        page?: number,
        /**
         * The number of items per page
         */
        pageSize?: number,
        /**
         * <b>Filtering on response attributes</b>
         * <p>
         * <details>
         * <summary><b>Supported operators:</b></summary>
         * <p></p>
         * </details>
         * <details>
         * <summary><b>Supported attributes - examples:</b></summary>
         * <p></p>
         * </details>
         * </p>
         * Filter is searched for presence of validFrom and validTo.
         * If those parts are missing following filter parts are added:
         * validFrom:lt {today};;validTo:gt {today}
         */
        filter?: string,
        /**
         * <b>Ordering ASC/DESC</b>
         */
        orderBy?: string,
    }): CancelablePromise<Gsoa_ActionOffers_ActionProducts> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/actionOffers/houses/{houseNumber}/actionProducts',
            path: {
                'apiVersion': apiVersion,
                'houseNumber': houseNumber,
            },
            query: {
                'page': page,
                'pageSize': pageSize,
                'filter': filter,
                'orderBy': orderBy,
            },
            errors: {
                304: `Not Modified`,
                400: `Validation error.`,
                401: `An error occurred.`,
                404: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static getActionProductsMetadata({
        houseNumber,
        apiVersion = 1,
        page,
        pageSize = 50,
        filter,
        orderBy,
    }: {
        houseNumber: number,
        apiVersion?: number,
        /**
         * Page order number (starts at 0)
         */
        page?: number,
        /**
         * The number of items per page
         */
        pageSize?: number,
        /**
         * <b>Filtering on response attributes</b>
         * <p>
         * <details>
         * <summary><b>Supported operators:</b></summary>
         * <p></p>
         * </details>
         * <details>
         * <summary><b>Supported attributes - examples:</b></summary>
         * <p></p>
         * </details>
         * </p>
         * Filter is searched for presence of validFrom and validTo.
         * If those parts are missing following filter parts are added:
         * validFrom:lt {today};;validTo:gt {today}
         */
        filter?: string,
        /**
         * <b>Ordering ASC/DESC</b>
         */
        orderBy?: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'HEAD',
            url: '/api/v{apiVersion}/gsoa/actionOffers/houses/{houseNumber}/actionProducts',
            path: {
                'apiVersion': apiVersion,
                'houseNumber': houseNumber,
            },
            query: {
                'page': page,
                'pageSize': pageSize,
                'filter': filter,
                'orderBy': orderBy,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Server Error`,
            },
        });
    }
    /**
     * Kolekce produktů
     * @returns Gsoa_ActionOfferProductCatalog_Products OK
     * @throws ApiError
     */
    public static getActionProductsCatalog({
        houseNumber,
        apiVersion = 1,
        filter,
        orderBy,
        useRebatesVersion,
        listedProductOnly = true,
        fields,
        filterProductsCatalog,
        page,
        pageSize = 50,
    }: {
        houseNumber: number,
        apiVersion?: number,
        /**
         * <b>Filtering on response attributes</b>
         * <p>
         * <details>
         * <summary><b>Supported operators:</b></summary>
         * <p></p>
         * </details>
         * <details>
         * <summary><b>Supported attributes - examples:</b></summary>
         * <p></p>
         * </details>
         * </p>
         * Filter is searched for presence of validFrom and validTo.
         * If those parts are missing following filter parts are added:
         * validFrom:lt {today};;validTo:gt {today}
         */
        filter?: string,
        /**
         * <b>Ordering ASC/DESC</b>
         */
        orderBy?: string,
        useRebatesVersion?: number,
        listedProductOnly?: boolean,
        /**
         * String represents list of fields split by delimiters ;.
         * <details>
         * <summary><b>Supported attributes - examples:</b></summary>
         * <p>
         * vanr;ean;productTagIds;warengroup;name;productInHouse;unitId;placementOrder;imgIcon;imgThumbnail;modified;brand;description;contains;imgDetail;allergens;nutritionValues;producer;storage;alias;rabatNumber;originalRebateId </br>
         * vanr;ean;modified </br>
         * vanr;ean;productInHouse </br>
         * </p>
         * </details>
         */
        fields?: string,
        /**
         * <b>Filtering on response attributes</b>
         * <p>
         * <details>
         * <summary>Supported operators:</summary>
         * <p><i>in</i> - checks if attribute equals one of posibilities. Case sensitive when literal attribute.</p>
         * </details>
         * <details>
         * <summary>Supported attributes - examples:</summary>
         * <p>
         * producerId:in Abc,def,ghi </br>
         * productCategories:in Abc,def,ghi </br>
         * countriesOfOrigin:in Abc,def,ghi </br>
         * commonBrandId:in Abc,def,ghi </br>
         * ean:in Abc,def,ghi </br>
         * vanr:in Abc,def,ghi </br>
         * productTagIds:in Abc,def,ghi </br>
         * rabatNumber:in Abc,def,ghi </br>
         * originalRebateId:in Abc,def,ghi </br>
         * </p>
         * </details>
         * Combinations possible, concatenation with ";;" means logical AND. E.g.: producerId:in Abc,def,ghi;;productCategories:in Abc,def,ghi
         * </p>
         */
        filterProductsCatalog?: string,
        /**
         * Page order number (starts at 0)
         */
        page?: number,
        /**
         * The number of items per page
         */
        pageSize?: number,
    }): CancelablePromise<Gsoa_ActionOfferProductCatalog_Products> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/actionOffers/houses/{houseNumber}/actionProductsCatalog',
            path: {
                'apiVersion': apiVersion,
                'houseNumber': houseNumber,
            },
            query: {
                'filter': filter,
                'orderBy': orderBy,
                'useRebatesVersion': useRebatesVersion,
                'listedProductOnly': listedProductOnly,
                'fields': fields,
                'filter-productsCatalog': filterProductsCatalog,
                'page': page,
                'pageSize': pageSize,
            },
            errors: {
                304: `Not Modified`,
                400: `Validation error.`,
                401: `An error occurred.`,
                403: `An error occurred.`,
                404: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
}
